export const calculateTextAccuracy = (correctText: string | null | undefined, inputText: string | null | undefined): number | null => {
  if (!correctText) return null;

  const correct = correctText.toLowerCase();
  const input = (inputText || '').toLowerCase();

  if (correct.length === 0) return null;
  if (correct === input) return 100;

  const rows = correct.length + 1;
  const cols = input.length + 1;
  const dp = Array.from({ length: rows }, () => new Array<number>(cols).fill(0));

  for (let i = 0; i < rows; i += 1) dp[i][0] = i;
  for (let j = 0; j < cols; j += 1) dp[0][j] = j;

  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      if (correct[i - 1] === input[j - 1]) {
        dp[i][j] = dp[i - 1][j - 1];
      } else {
        dp[i][j] = Math.min(
          dp[i - 1][j - 1], // substitution
          dp[i - 1][j],     // deletion
          dp[i][j - 1],     // insertion
        ) + 1;
      }
    }
  }

  const distance = dp[rows - 1][cols - 1];
  const total = correct.length;
  const correctChars = Math.max(total - distance, 0);
  const score = (correctChars * 100) / total;
  return Math.round(score * 10) / 10;
};

